function initAutoDash() {
  const autoDashDates = document.querySelectorAll( '[autocomplete="bday"]' );

  if (autoDashDates) {
    [...autoDashDates].forEach( (element) => {
      element.addEventListener( 'keyup', (event) => {
        if (event.key !== 'Backspace' && (element.value.length === 2 || element.value.length === 5)) {
          element.value += '-';
        }
      } );
    } )
  }
}

function addInvalidClass() {
  document.addEventListener( 'invalid', function (e) {
    const invalidAmounts = document.querySelector( '[name="bedrag"]:invalid' );
    const validateAmountAmounts = document.querySelector( '.validate-amount-amounts' );

    if (validateAmountAmounts) {
      if (invalidAmounts) {
        validateAmountAmounts.style.display = 'block';
      } else {
        validateAmountAmounts.style.display = 'none';
      }
    }

    const invalidWebsitekeys = document.querySelector( '[name="websitekey"]:invalid' );
    const validateAmountWebsitekeys = document.querySelector( '.validate-amount-websitekey' );

    if (validateAmountWebsitekeys) {
      if (invalidWebsitekeys) {
        validateAmountWebsitekeys.style.display = 'block';
      } else {
        validateAmountWebsitekeys.style.display = 'none';
      }
    }

    const invalidFormEntries = document.querySelectorAll( ':invalid' );
    const hasInvalidClass = document.querySelectorAll( '.invalid' );

    if (hasInvalidClass.length > 0) {
      [...hasInvalidClass].forEach( (element) => {
        element.classList.remove( 'invalid' );
      } );
    }

    if (invalidFormEntries.length > 0) {
      [...invalidFormEntries].forEach( (element) => {
        element.classList.add( 'invalid' );
      } );
    }
    // e.target.className += ' invalid';
  }, true );
}

export default {
  init() {
    initAutoDash();
    addInvalidClass();
  },
};